module.exports = __webpack_public_path__ + "static/media/con_spa_tra_sup.ca93a9e9.png";